<template>
  <div>
    <header class="header">
      <div class="header-left">
        <a>
          <img src="/static/image/top_bg_right-1.png" />
        </a>
      </div>
      <div class="top-right">
        <div class="user-login" v-if="$store.state.token">
          <a @click="$parent.goNav('/')">{{ $t('header.home') }}</a> &nbsp;|&nbsp;
          <a class="shiwan" @click="$parent.goNav('/mine/center')" >{{ $store.state.userInfo.username ? $store.state.userInfo.username : '' }}</a>
          &nbsp;|&nbsp; <a @click="outLogin">{{ $t('header.Signout') }}</a>
        </div>
        <div class="user-login" v-else>
          <a @click="$parent.goNav('/')"
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.home') }}</font></font></a
          ><font style="vertical-align: inherit"><font style="vertical-align: inherit"> &nbsp;| </font><font style="vertical-align: inherit">{{ $t('header.Notmember') }} </font></font
          ><a @click="$parent.goNav('/register')"
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.register') }}</font></font></a
          >
        </div>
        <a v-if="$store.state.token" @click="$parent.goNav('/activityapyList')" target="_blank" class="free-demo">
          <div class="free-dem-a">{{ $t('header.review') }}</div>
        </a>
        <a v-else @click="$parent.goNav('/login')" target="_blank" class="free-demo">
          <div class="free-dem-a">{{ $t('header.review') }}</div>
        </a>
      </div>
      <img style="margin-top: -55px" class="header-logo" src="/static/image/logo1-1.png" />
    </header>
    <div class="gonggao">
      <div class="title"><img src="/static/image/guanggao.png" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('index.announcement') }}</div>
      <div class="gundong" @click="$parent.goNav('/message?type=1')">
        <marquee scrollamount="8" scrolldelay="100" direction="left" onclick="hotNewsHistory()" onmouseover="this.stop();" onmouseout="this.start();"
          >{{ $t('index.official') }}
        </marquee>
      </div>
    </div>
    <div class="app-content on">
      <div class="activity-city">
        <ul id="activityTab" class="activity-tab">
          <li :class="actType == '' ? 'tab' : ''" @click="changActType('')">{{ $t('header.Alloffers') }}</li>
          <li :class="actType == item.id ? 'tab' : ''" @click="changActType(item.id)" v-for="(item, index) in activitytypeList" :key="index">{{ item.name }}</li>
        </ul>
        <div class="activity-content clearfix">
          <ul id="activitylist">
            <li class="activity-item" v-for="(item, index) in activitylistList" v-if="item.state == 1" :key="index">
              <a @click="$parent.goNav(`/activityInfo?id=${item.id}`)"
                ><div class="container_center">
                  <img src="/static/image/r_btn.png" />
                </div>
                <!-- noImg.png @errοr="this.src='/static/image/noImg.png'" -->

                <img class="activity-image" :src="item.banner" />
              </a>
              <p class="iamge-titile">{{ item.title }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer">
        <div class="content">
          <div class="sponsors"></div>
          <div class="foot-nav">
            <div class="copyright all-rights">© 2022 {{$store.state.appInfo.title}} All rights Reserved</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activity',
  data() {
    return {
      activitytypeList: [],
      actType: '',
      activitylistList: [],
    };
  },
  created() {
    let that = this;
    that.activitytype();
    that.activitylist();
  },
  methods: {
    outLogin() {
      let that = this;
      that.$parent.outLogin();
    },
    activitytype() {
      let that = this;
      that.$apiFun.post('/api/activitytype', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitytypeList = res.data;
        }
      });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
    changActType(val) {
      let that = this;
      if (val == that.actType) {
        return;
      }
      that.actType = val;
      that.activitylist();
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../static/css/style-1.css';
iframe[src*='ucweb.com'] {
  display: none !important;
}
iframe[id^='head__'] {
  display: none !important;
}
iframe[id^='utp__'] {
  display: none !important;
}
.iamge-titile {
  font-weight: 600;
  color: #ccc;
}
.activity-tab li {
  color: #ccc;
}
.image-pc {
  display: none;
}
.image-app {
  display: block;
}
@media screen and (min-width: 768px) {
  .activity-city {
    width: 1200px;
  }
  .activity-item {
    width: 290px;
    padding: 0 0 10px 0;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 10px;
    margin-bottom: 20px;
    background-image: url(/static/image/mxbg.jpg);
  }
  .container_center {
    width: 290px;
    height: 178px;
    border-radius: 5px;
    overflow: hidden;
  }
  .container_center img {
    margin-left: 93px;
    margin-top: 73px;
  }
  .image-pc {
    display: block;
  }
  .image-app {
    display: none;
  }
  .activity-image {
    height: auto;
  }
  .activity-item .activity-image {
    height: 176.94px;
  }
}
@media screen and (max-width: 768px) {
  .activity-item {
    overflow: hidden;
    border-radius: 5px;
    margin-bottom: 10px;
    width: 49%;
    padding: 0 0 6px 0;
    margin-right: 1%;
  }
  .activity-image {
    width: 100%;
    margin: 0 auto;
    border-radius: 5px;
  }
  #activitylist {
    width: 100%;
    padding-left: 1%;
  }
  .app-content {
    width: 100%;
    left: 0;
    top: 95px;
  }
  .iamge-titile {
    font-size: 13px;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .activity-item:hover .container_center {
    display: none;
  }
}
#app{
  background: none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/activity.vue